import { ColumnDetails, ColumnType } from '../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../utils/translator.helper';
import { getExclusionItemTypeGridValues } from '../../../../utils/uiSettings/storageProtection/storage-protection.values';

export enum Column {
  TYPE = 1,
  PATH,
  DESCRIPTION,
}

export enum ColumnKeys {
  TYPE = 'type',
  PATH = 'path',
  DESCRIPTION = 'description',
}

export const GRID_COLUMNS = [Column.TYPE, Column.PATH, Column.DESCRIPTION];

export function getGridColumnDetails(): Array<ColumnDetails<Column, ColumnKeys>> {
  return [
    {
      column: Column.TYPE,
      key: ColumnKeys.TYPE,
      columnName: translateFn('Type'),
      type: ColumnType.ENUM,
      values: getExclusionItemTypeGridValues(),
      removable: false,
      filteringDisabled: true,
      sortable: true,
      editingDisabled: true,
    },
    {
      column: Column.PATH,
      key: ColumnKeys.PATH,
      columnName: translateFn('Path'),
      type: ColumnType.STRING,
      removable: false,
      filteringDisabled: true,
      sortable: true,
    },
    {
      column: Column.DESCRIPTION,
      key: ColumnKeys.DESCRIPTION,
      columnName: translateFn('Description'),
      type: ColumnType.STRING,
      removable: false,
      filteringDisabled: true,
      sortable: true,
    },
  ];
}
